// src/routes/index.tsx
import React, { Suspense, useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useGenerateRoutes } from "../hooks/useGenerateRoutes";
import Loader from "../components/CustomLoader";

const RoutesComponent: React.FC = () => {
  const routes = useGenerateRoutes();
  // console.log(routes,"routes");

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  return (
    <Suspense fallback={<Loader force={true} />}> {/* fallback loader */}
      <RouterProvider router={router} />
    </Suspense>
  )
};

export default RoutesComponent;
